goog.provide('el8.appchart.visitNote.subBulletDialog');

goog.require('el8.uiwidget.NewDialog');
goog.require('el8.template.appchart.visitNote.subBulletDialog');

el8.appchart.visitNote.subBulletDialog = (function() {

    var callbackFn = null;

    var that = new el8.uiwidget.NewDialog({
        title: 'Select where to add as sub-bullet',
        autoHeight: true,
        width: 400,
        modal: true,
        contentFn: function() {
            return el8.template.appchart.visitNote.subBulletDialog.content();
        },
        showXButton: true
    });

    var super_init = that._init;
    that._init = function() {
        super_init.call(that);
        $(that.getContentElt()[0]).on('click', '.sub-bullet', function(e) {
            var index = $(this).attr('_index');
            that.hide();
            if (callbackFn) { callbackFn(index); }
        });
    };

    var super_show = that.show;
    that.show = function(list, _callbackFn) {
        callbackFn = _callbackFn;
        super_show.call(that);
        $('.sub-bullets-content', that.getContentElt()).html(
            el8.template.appchart.visitNote.subBulletDialog.list({
                list: list.map(function(a) { return a.getText(); })
            })
        );
        that.adjustHeight();
    };

    return that;

})();
